import { fileDownload } from 'Admin/Component/AdFunc'
import '_Asset/css/User/Page/UiComponent/palette.css'

const PltList = ({item}) => {
  return (
    <div className={`pltGroup ${item.model}`}>
      <span className="plt"></span>
      <div className="colorInfo">
        <strong className={item.model}>{item.name ? item.name : item.model}</strong>
        <p>{item.hex}</p>
      </div>
    </div>
  )
}

const Palette = () => {

  const color = [
    {
      colorList: [
        {model: "pgNavy_400", name: "PayGate Navy", hex: "#373157" },
        {model: "pgYellow_400", name: "PayGate Yellow", hex: "#DFAD1A" },
        {model: "pgBlack", name: "PayGate Black", hex: "#2C2728" },
        {model: "sfrtBlue", name: "Seyfert Blue", hex: "#4172B5" },
      ]
    },
    {
      colorList: [
        {model: "gray_400", name: "Main Gray", hex: "#2C2728" },
        {model: "gray_300", name: "Dark Gray", hex: "#666666" },
        {model: "gray_200", name: "Gray", hex: "#999999" },
        {model: "gray_100", name: "Light Gray", hex: "#CCCCCC" },
      ]
    },
    {
      colorList: [
        {model: "success", name: "Success", hex: "#39af8a" },
        {model: "error", name: "Error", hex: "#FF3C45" },
        {model: "info", name: "Info", hex: "#4172B5" },
        {model: "alert", name: "Alert", hex: "#DFAD1A" },
      ]
    }
  ]
  
  return (
    <div className="componentBox">
      <div className="pageTit">
        <h2>UI Colors <button type="button" className="btn round_10 sm sfrtBlue" onClick={() => fileDownload('ui_component', 'pgui.css')}>UI Component CSS 다운로드</button></h2>
      </div>

      <div className="useWay">
        <h2>How to use the UI Colors kit</h2>
        <p>Click on the palette to copy the color code.</p>
      </div>

      {/* PayGate Logo Color */}
      <div className="layoutCont">
        <div className="tit">
          <h2>PayGate Logo Color</h2>
        </div>

        <div className="contWrap row">
          {
            color[0].colorList.map((item, i) => 
              <PltList key={i} item={item} />
            )
          }
        </div>
      </div>


      {/* Style Colors */}
      <div className="layoutCont">
        <div className="tit">
          <h2>Text Colors</h2>
        </div>

        <div className="contWrap row">
          {
            color[1].colorList.map((item, i) => 
              <PltList key={i} item={item} />
            )
          }
        </div>
      </div>

      {/* System Colors */}
      <div className="layoutCont">
        <div className="tit">
          <h2>System Colors</h2>
        </div>

        <div className="contWrap row">
          {
            color[2].colorList.map((item, i) => 
              <PltList key={i} item={item} />
            )
          }
        </div>
      </div>
    </div>
  )
}

export default Palette